import React, { useState } from "react";
import styled from "styled-components";
import { Modal } from "antd";
import COLORS from "common/Colors";
import diamondIcon from "assets/timesheeticons/DiamondSvg.svg";

export const InstructionsTrigger = ({ className }) => {
  const [open, setOpen] = useState(false);

  return (
    <>
      <InstructionsLink className={className} onClick={() => setOpen(true)}>
        Instructions
      </InstructionsLink>
      <InstructionsModal
        open={open}
        onCancel={() => setOpen(false)}
        footer={null}
        closable={true}
        centered={true}
        width={480}
        title={
          <ModalTitle>
            <img src={diamondIcon} alt="" className="diamond" /> Instructions
          </ModalTitle>
        }
      >
        <InstructionsModalContent />
      </InstructionsModal>
    </>
  );
};

const InstructionsModalContent = () => {
  return (
    <InstructionsModalContentWrap>
      <div className="hint">
        <p className="hint-heading">
          Please remember the following when you fill in your timesheet:
        </p>
        <ul>
          <li>
            The week-ending date is the SUNDAY of the work week that you are
            reporting on.
          </li>
          <li>Time is recorded in manhours (8 hrs = 1 manday).</li>
          <li>
            You may modify entry values as long as the individual entry is
            not approved.
          </li>
        </ul>
      </div>

      <div className="fact">
        <p className="hint-heading">Retract Function:</p>
        <ul>
          <li>
            You may retract the pending approve timesheet items for the
            specified weekending timesheet.
          </li>
          <li>
            Retract timesheet will 'reopen' the pending approve timesheet
            items only.
          </li>
        </ul>
      </div>
    </InstructionsModalContentWrap>
  );
};

const TimeSheetFooterHint = () => {
  return (
    <TimeSheetFooterHintWrap>
      <div className="hint">
        <p>
          <span className="hint-heading">
            Please remember the following when you fill in your timesheet:
          </span>{" "}
          <br />
          - The week-ending date is the SUNDAY of the work week that you are
          reporting on. <br />
          - Time is recorded in manhours (8 hrs = 1 manday). <br />- You may
          modify entry values as long as the individual entry is not approved.
        </p>
      </div>

      <div className="fact">
        <p>
          <span className="hint-heading">Retract Function:</span> <br />
          - You may retract the pending approve timesheet items for the
          specified weekending timesheet. <br />- Retract timesheet will
          'reopen' the pending approve timesheet items only.
        </p>
      </div>
    </TimeSheetFooterHintWrap>
  );
};

export default TimeSheetFooterHint;

const InstructionsLink = styled.span`
  color: #26a4ff;
  cursor: pointer;
  font-weight: 500;

  &:hover {
    text-decoration: underline;
  }
`;

const ModalTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 600;
  font-size: 17px;

  .diamond {
    width: 46px;
    height: 36px;
  }
`;

const InstructionsModal = styled(Modal)`
  .ant-modal-header {
    background: ${COLORS.PRIMARY};
    padding: 16px 24px;
  }
  .ant-modal-title {
    color: #ffffff;
  }
  .ant-modal-close {
    color: #ffffff;
  }
  .ant-modal-content {
    border-radius: 10px;
    overflow: hidden;
    padding: 0;
  }
  .ant-modal-body {
    padding: 20px 24px;
  }
`;

const InstructionsModalContentWrap = styled.div`
  p {
    margin: 0;
  }

  ul {
    margin: 8px 0 0;
    padding-left: 18px;
  }

  .hint {
    margin-bottom: 16px;
    .hint-heading {
      font-weight: 600;
    }
  }

  .fact {
    .hint-heading {
      font-weight: 600;
    }
  }
`;

const TimeSheetFooterHintWrap = styled.div`
  margin-top: 20px;
  p {
    margin: 0;
  }

  .hint {
    margin-bottom: 12px;
    .hint-heading {
      /* font-weight: bold; */
      font-size: Medium;
    }
  }

  .fact {
    box-shadow: 0px 3px 6px #00000015;
    border-radius: 5px;
    padding: 0.5rem;

    .hint-heading {
      font-size: Medium;
    }
  }
`;
